import BossModel from "@/models/BossModel";
import Passenger from "@/models/Agent/Reservation/Passenger/Passenger";
import Product from "@/models/Agent/Product/Product";

export default class Reservation extends BossModel {

    static apiUrl = 'agent/reservation';

    static entity = 'agentReservations';

    static fields() {
        return {
            id: this.number(null).nullable(),
            dossier_id: this.number(),
            agent_id: this.number(),
            agent_eid: this.string(),
            passengers: this.hasMany(Passenger, 'agent_reservation_id'),
            agentProducts: this.hasMany(Product, 'agent_reservation_id'),
        }
    }

    async import() {
        return this.constructor.api().action(this.id + '/import').beforeInsert(() => {
            Product.query().delete(product => {
                return product.agent_reservation_id === this.id;
            });
        }).getSingle();
    }

    updatePassengers(passengers) {
        return this.constructor.api().action(this.id + '/passengers').update({passengers: passengers});
    }
}
